import { createSelector } from 'reselect';

import { DocumentListDocumentItem } from '../components/documentList/types';
import { StoreState } from '../types/store';

import { getCurrentCompanyEdrpou, getCurrentUserRoleId } from './app.selectors';

import {
    getIsOnlyCanNotSignDocuments,
    getIsOnlyExtraSignatureDocuments,
    getIsOnlyNotReadyToSignAfterReviewDocuments,
    getIsOnlySignDocuments,
} from '../services/documents/utils';

export const getDLSlice = (state: StoreState) => state.documentList;
export const getDocumentListLoading = (state: StoreState): boolean =>
    getDLSlice(state).loading;

export const getDocumentListItems = (
    state: StoreState,
): DocumentListDocumentItem[] => getDLSlice(state).documents;

export const getUnsuccessfullySignedDocuments = (
    state: StoreState,
): Record<string, Record<'error', string>> =>
    getDLSlice(state).unsuccessfullySignedDocuments;

export const getDateSortType = (state: StoreState) =>
    getDLSlice(state).dateSortType;

export const getSelectedDocuments = createSelector(
    getDocumentListItems,
    (documents) => documents.filter((item) => item.selected),
);

export const getSelectedAsicDocuments = createSelector(
    getSelectedDocuments,
    (documents) => documents.filter((item) => item.hasEUSignatures),
);

export const getDocumentActions = (
    state: StoreState,
): DocumentListDocumentItem[] => getDLSlice(state).documentActions;

export const getSingleSelectedDocuments = createSelector(
    getSelectedDocuments,
    (documents) => (documents.length === 1 ? documents[0] : null),
);

export const getSelectAllDocuments = (state: StoreState) =>
    getDLSlice(state).isSelectedAll;

export const getDocumentsCountByFilter = (state: StoreState) =>
    getDLSlice(state).documentsCount;

export const getIsOnlyExtraSignatureDocumentsSelector = createSelector(
    getSelectedDocuments,
    getCurrentUserRoleId,
    getCurrentCompanyEdrpou,
    (selectedDocuments, currentRoleId, currentCompanyEdrpou) =>
        getIsOnlyExtraSignatureDocuments(
            selectedDocuments,
            currentRoleId,
            currentCompanyEdrpou,
        ),
);

export const getIsOnlyNotReadyToSignAfterReviewDocumentsSelector = createSelector(
    getSelectedDocuments,
    (selectedDocuments) =>
        getIsOnlyNotReadyToSignAfterReviewDocuments(selectedDocuments),
);

export const getIsOnlyCanNotSignDocumentsSelector = createSelector(
    getSelectedDocuments,
    getCurrentUserRoleId,
    getCurrentCompanyEdrpou,
    (selectedDocuments, currentRoleId, currentCompanyEdrpou) =>
        getIsOnlyCanNotSignDocuments(
            selectedDocuments,
            currentRoleId,
            currentCompanyEdrpou,
        ),
);

export const getIsOnlySignDocumentsSelector = createSelector(
    getSelectedDocuments,
    getCurrentUserRoleId,
    (selectedDocuments, currentRoleId) =>
        getIsOnlySignDocuments(selectedDocuments, currentRoleId),
);
